import PropTypes from 'prop-types';

import  Box  from '@mui/material/Box';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';

import Iconify from 'src/components/iconify';
import Label from 'src/components/label/index';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

const STATUS_MAP = [
  { value: 'Pending',
    element: <Label
      color="warning"
      sx={{ textTransform: 'uppercase' }}
    >
      Pendiente
    </Label>},
  { value: "Canceled",
    element: <Label
      color="error"
      sx={{ textTransform: 'uppercase' }}
    >
      Cancelado
    </Label>},
  { value: "Received",
    element: <Label
      color="success"
      sx={{ textTransform: 'uppercase' }}
    >
      Recibido
    </Label>},
]

export default function CheckRequestTableRow({ row, selected, onSelectRow, onDeleteRow, approveRequest, CancelRequest, editRequest, setSelected }) {
  const { checkNumber, bankAccount, isDeleted, checkDate, receivedDate, description, creationDate, recievedName, createdBy, amount } = row;

  const popover = usePopover();

  // Manejar recievedName que puede ser string o objeto
  const receivedNameData = typeof recievedName === 'string' 
    ? { name: recievedName, identification: "N/A" }
    : recievedName || { name: "N/A", identification: "N/A" };
  const getStatus = () =>{
    if (isDeleted === 1) {
        return "Canceled"
      } if ((new Date(receivedDate) > new Date()) || receivedDate === undefined || receivedDate === null) {
        return "Pending";
      } if (new Date(receivedDate) <= new Date()){
        return "Received"; 
      }
      return null
  }

  const formatMoney = (Amount, currency = 'USD', locale = 'en-US') =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(Amount);
  

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>

        <TableCell sx={{display: "table-cell", textAlign: "center", verticalAlign: "middle"}}>
        
          {checkNumber}
        </TableCell>

        <TableCell sx={{display: "table-cell", textAlign: "center"}}><Label
          color="info"
          sx={{ textTransform: 'uppercase' }}
        >
          {bankAccount?.name}
        </Label></TableCell>


        <TableCell sx={{display: "table-cell", textAlign: "center"}}>
          {formatMoney(amount,'DOP', 'es-DO')}</TableCell>

        <TableCell sx={{display: "table-cell", textAlign: "center"}}>
          {description}
        </TableCell>

        <TableCell sx={{display: "table-cell", textAlign: "center"}}>
         {creationDate
            ? new Date(creationDate).toLocaleDateString('es-DO', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })
            : "Pendiente"}
        </TableCell>

        <TableCell sx={{ display: "table-cell", textAlign: "center" }}>
          {checkDate
            ? new Date(checkDate).toLocaleDateString('es-DO', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })
            : "Pendiente"}
        </TableCell>

        <TableCell sx={{display: "table-cell", textAlign: "center"}}><ListItemText
            disableTypography
            primary={
              <Typography variant="body2" noWrap>
                {getStatus() === "Received" && shortFullName(receivedNameData.name)}
                {getStatus() === "Pending" && STATUS_MAP.find(x => x.value === getStatus())?.element}
                {getStatus() === "Canceled" && STATUS_MAP.find(x => x.value === getStatus())?.element}
              </Typography>
            }
            secondary={
              <Box>
        <Link
          noWrap
          variant="body2"
          sx={{ color: 'text.disabled', cursor: 'default' }}
        >
          {getStatus() === "Received" && receivedNameData.identification}
        </Link>

        {getStatus() === "Received" && (
          <Typography variant="caption" sx={{ display: 'block', color: '#637381' }}>
            {creationDate}
          </Typography>
        )}
      </Box>
            }
            
          /></TableCell>

        <TableCell sx={{display: "table-cell", textAlign: "center"}}>{shortFullName(createdBy)}</TableCell>

        <TableCell align="right" sx={{ px: 1 }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={(event) => {
            popover.onOpen(event);
            setSelected(row);
          }}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>


          {/* three points to options */}
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
          sx={{ width: 200 }}
      >


        <MenuItem
          onClick={() => {
            editRequest.onTrue();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Editar
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />

          <MenuItem
          onClick={() => {
            approveRequest.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'success.main' }}
          disabled={getStatus() === "Received" || getStatus() === "Canceled"}
        >
          <Iconify icon="solar:archive-minimalistic-bold-duotone" />
          Recibido
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={() => {
            CancelRequest.onTrue();
            popover.onClose();
          }}
          disabled={getStatus() === "Canceled"}
          sx={{ color: 'warning.main' }}
        >
          <Iconify icon="lets-icons:cancel-duotone" />
          Cancelar
        </MenuItem>



      </CustomPopover>
       
    
    </>
  );
}

const shortFullName = (Fullname) => {
  if (!Fullname) return "N/A";
  if (typeof Fullname === 'string') return Fullname;
  return `${Fullname.name || ''} ${Fullname.lastName || ''}`.trim() || "N/A";
};

CheckRequestTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
  approveRequest: PropTypes.object,
  CancelRequest: PropTypes.object,
  editRequest: PropTypes.object,
  setSelected: PropTypes.func,
};
